var $ce3de3ff2fd66848$exports = {};
$ce3de3ff2fd66848$exports = {
  "ascending": "\u062A\u0635\u0627\u0639\u062F\u064A",
  "ascendingSort": function ascendingSort(args) {
    return "\u062A\u0631\u062A\u064A\u0628 \u062D\u0633\u0628 \u0627\u0644\u0639\u0645\u0648\u062F ".concat(args.columnName, " \u0628\u062A\u0631\u062A\u064A\u0628 \u062A\u0635\u0627\u0639\u062F\u064A");
  },
  "columnSize": function columnSize(args) {
    return "".concat(args.value, " \u0628\u0627\u0644\u0628\u0643\u0633\u0644");
  },
  "descending": "\u062A\u0646\u0627\u0632\u0644\u064A",
  "descendingSort": function descendingSort(args) {
    return "\u062A\u0631\u062A\u064A\u0628 \u062D\u0633\u0628 \u0627\u0644\u0639\u0645\u0648\u062F ".concat(args.columnName, " \u0628\u062A\u0631\u062A\u064A\u0628 \u062A\u0646\u0627\u0632\u0644\u064A");
  },
  "resizerDescription": "\u0627\u0636\u063A\u0637 \u0639\u0644\u0649 \u0645\u0641\u062A\u0627\u062D Enter \u0644\u0628\u062F\u0621 \u062A\u063A\u064A\u064A\u0631 \u0627\u0644\u062D\u062C\u0645",
  "select": "\u062A\u062D\u062F\u064A\u062F",
  "selectAll": "\u062A\u062D\u062F\u064A\u062F \u0627\u0644\u0643\u0644",
  "sortable": "\u0639\u0645\u0648\u062F \u0642\u0627\u0628\u0644 \u0644\u0644\u062A\u0631\u062A\u064A\u0628"
};
export { $ce3de3ff2fd66848$exports as default };